import { render } from "./MidnightSplitTable.vue?vue&type=template&id=838603b6&ts=true"
import script from "./MidnightSplitTable.ts?vue&type=script&lang=ts&external"
export * from "./MidnightSplitTable.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__